import { Component } from '@angular/core';
import { FormGroup, FormControl, Validators, AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';
import { IItem } from '@coreui/angular-pro'
import { RestService } from 'src/app/services/rest/rest.service';
import { GenericResponse, RetailCustomer } from 'src/app/interfaces/apiresponses'; 

@Component({
  selector: 'app-retail-admin',
  templateUrl: './retail-admin.component.html',
  styleUrls: ['./retail-admin.component.scss']
})
export class RetailAdminComponent {
  selectedSearchButton: number = 1
  searchBtnColor = 'secondary'
  searchAllBtnColor = 'secondary'
  customerProfileForm!:FormGroup
  bShowCustomer: boolean = false
  bCustomerActive: boolean = false
  
  constructor(
    private restApi: RestService) { 
      // this.customerProfileForm = new FormGroup({
      //   customerName: new FormControl(null),
      //   customerCIF: new FormControl(null),
      //   customerEmail: new FormControl(null),
      //   customerMobile: new FormControl(null)
      // })
  }

  // Alert buttons
  bAlert = false
  alertHeaderText = ""
  alertBodyText = ""
  bShowSecondAlertButton = false
  alertSecondButtonText = ""
  alertCloseButtonText = "Close"
  alertBoxData: any

  closeAlert(event: any){

  }

  alertVisibility(event: any)
  {
    this.bAlert = event.state
  }

  showAlertBox(heading: string, body: string, closeButtonText: string = "Close", showSecondButton: boolean = false, secondButtonText: string = "Understood", data: any = {})
  {
    this.alertHeaderText = heading
    this.alertBodyText = body
    this.bShowSecondAlertButton = showSecondButton
    this.alertSecondButtonText = secondButtonText
    this.alertCloseButtonText = closeButtonText
    this.alertBoxData = data
    this.bAlert = true
  }

  onAlertButtonClick(event: any){
    this.bAlert = event.state
    if (event.data.action === 1){
      this.resetPassword()
    }
  }

  // Search Form
  searchEmail: any = ''
  cifSearchForm = new FormGroup({
    searchByEmailControl: new FormControl(this.searchEmail, [Validators.required, Validators.pattern(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]),
  })

  get searchByEmailControl() {return this.cifSearchForm.get('searchByEmailControl')}
  customerEmailValid!: boolean
  isCustomerEmailValid(){
    let returnVal = ''

    if (this.searchByEmailControl?.invalid && (this.searchByEmailControl?.dirty || this.searchByEmailControl?.touched))
    {
      this.customerEmailValid = false
      if (this.searchByEmailControl?.errors?.['required'])
        returnVal =  'Email is required'
      else if (this.searchByEmailControl?.errors?.['pattern'])
        returnVal = 'Please enter a valid email ID'
      else
        returnVal = 'Please enter a valid email ID'
    } else {
      returnVal = ''
      if (this.searchByEmailControl?.dirty || this.searchByEmailControl?.touched)
      {
        this.customerEmailValid = true
      }
    }
    
    return returnVal
  }
  columns = [
    {
      key: 'cif',
      label: 'CIF',
      _cellProps: {align: 'middle'},
      filter: true
    },
    {
      key: 'name',
      label: 'Customer Name',
      _cellProps: {align: 'middle'},
      filter: true
    },
    {
      key: 'email',
      label: 'Email ID',
      _cellProps: {align: 'middle'},
      filter: true
    },
    {
      key: 'mobile',
      label: 'Mobile',
      _cellProps: {align: 'middle'},
      filter: true
    },
    {
      key: 'userId',
      label: 'Action',
      filter: false
    },
  ];

  usersData: IItem[] = []
  selectedItems = [2, 3];

  rowSelected(event: any){
  }

  selectedCustomerId: number = 0
  get customerName() { return this.customerProfileForm.get('customerName') }
  get customerEmail() { return this.customerProfileForm.get('customerEmail')}
  get customerMobile() { return this.customerProfileForm.get('customerMobile')}
  get customeCIF() { return this.customerProfileForm.get('customeCIF')}
  emailChange(){
    if (this.cifSearchForm.controls['searchByEmailControl'].value === '') {
      this.bShowCustomer = false
    }
  }
  getRetailCustomer(){
    console.log(this.cifSearchForm.value.searchByEmailControl)
   
    
    if (this.cifSearchForm.controls['searchByEmailControl'].value === '') {
      this.bShowCustomer = false
      this.showAlertBox('Oops!!', 'Email ID is required!')
      //this.customerProfileForm.reset()
      
      return
    }
    if (this.searchByEmailControl?.value == undefined && this.searchByEmailControl?.value == null)
    {
      return;
    }
   
      
      this.restApi.getRetailCustomer(this.cifSearchForm.value.searchByEmailControl).subscribe({
        next: (v: RetailCustomer) => {
          if (v.success){
            this.bShowCustomer = true
            this.selectedCustomerId = v.userId
            this.bCustomerActive = v.active

            this.customerProfileForm = new FormGroup({
              customerName: new FormControl(v.name),
              customerCIF: new FormControl(v.cif),
              customerEmail: new FormControl(v.email),
              customerMobile: new FormControl(v.mobile)
            })

            this.customerProfileForm.disable()
          } else {
            this.bShowCustomer = false
            this.showAlertBox('Sorry', 'There is no such customer with this email ID. Please try again.')
            this.customerProfileForm.reset()
          }

          
        },
        error: (e) => {
          this.bShowCustomer = false
          this.showAlertBox('Sorry', 'There is no such customer with this email ID. Please try again.')
          this.customerProfileForm.reset()
        }
      })
   
  }

  onRetailEmailIDChange(){

  }

  onCIFChange(){

  }

  goBackToOriginalScreen(){
    this.customerProfileForm.reset()
    this.bShowCustomer = false
  }

  resetPasswordPrompt(){
    this.showAlertBox('Confirm', 'Are you sure you want to reset the password of this customer?', 'No', true, 'Yes', {action: 1, matrixId: 0})
  }

  resetPassword(){
    if (this.customerEmail?.value != undefined && this.customerEmail?.value != null) {
      this.restApi.resetRetailCustomerPassword(this.customerEmail?.value).subscribe({
        next: (v: GenericResponse) => {          
          if (v.success) {
            this.showAlertBox('Success', 'Email sent successfully')
            this.goBackToOriginalScreen()
          } else {
            this.goBackToOriginalScreen()
            this.showAlertBox('Sorry', 'There was some technical error. Please contact the support')
          }
        },
        error: (e) => {
          this.goBackToOriginalScreen()
          this.showAlertBox('Sorry', 'There was some technical error. Please contact the support')
        }
      })
    }
    
  }
}
